import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, 
  FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn,
  FaYoutube, FaArrowRight, FaWhatsapp
} from 'react-icons/fa';
import { MdSend } from 'react-icons/md';

const Footer = () => {
  const [email, setEmail] = useState('');
  const currentYear = new Date().getFullYear();

  const handleSubscribe = (e) => {
    e.preventDefault();
    alert('Thank you for subscribing!');
    setEmail('');
  };

  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Mission & Vision', href: '/mission-vision' },
    { name: "Principal's Message", href: '/principal-message' },
    { name: 'Courses', href: '/courses' },
    { name: 'Admissions', href: '/admissions' },
    { name: 'Faculty', href: '/faculty' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Contact Us', href: '/contact-section' },
  ];

  const importantLinks = [
    { name: 'News & Events', href: '/news' },
    { name: 'Downloads', href: '/downloads' },
  ];

  // Updated socialLinks with actual URLs
  const socialLinks = [
    { 
      Icon: FaFacebookF, 
      color: "bg-blue-600", 
      hover: "hover:bg-blue-700", 
      url: "https://www.facebook.com/rdspharmacy" 
    },
    { 
      Icon: FaTwitter, 
      color: "bg-sky-500", 
      hover: "hover:bg-sky-600", 
      url: "#" // Add Twitter URL if available
    },
    { 
      Icon: FaInstagram, 
      color: "bg-pink-600", 
      hover: "hover:bg-pink-700", 
      url: "https://www.instagram.com/rdsgroup_of_colleges?igsh=MTNma2x6cTBwdGJwdA==" 
    },
    { 
      Icon: FaLinkedinIn, 
      color: "bg-blue-700", 
      hover: "hover:bg-blue-800", 
      url: "#" // Add LinkedIn URL if available
    },
    { 
      Icon: FaYoutube, 
      color: "bg-red-600", 
      hover: "hover:bg-red-700", 
      url: "https://youtube.com/@rdscollegeofpharmacy8349?si=Onm4n5PHvFADYa4q" 
    },
    { 
      Icon: FaWhatsapp, 
      color: "bg-green-500", 
      hover: "hover:bg-green-600", 
      url: "https://wa.me/919984485915" 
    },
  ];

  const contactDetails = [
    { Icon: FaMapMarkerAlt, text: <>RDS SNATAKOTTAR MAHAVIDYALAY<br />Uttar Pradesh, India</> },
    { Icon: FaPhoneAlt, text: <>9721707111<br />+91 7275 370 808</> },
    { Icon: FaEnvelope, text: <>rdscollege0342@gmail.com<br />info@rdsgroupofcolleges.com</> },
    { Icon: FaClock, text: <>Mon-Fri: 9:00 AM - 6:00 PM<br />Sat: 10:00 AM - 4:00 PM</> },
  ];

  const bottomLinks = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Use', href: '/terms-of-use' },
    { name: 'Sitemap', href: '/sitemap' },
  ];

  const LinkColumn = ({ title, links }) => (
    <div>
      <h3 className="text-lg font-bold text-white mb-4 relative">
        {title}
        <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-blue-600 mt-2"></span>
      </h3>
      <ul className="space-y-2">
        {links.map((link, idx) => (
          <li key={idx}>
            <Link to={link.href} className="text-white hover:text-blue-600 transition flex items-center gap-2 text-sm">
              <FaArrowRight className="text-xs" />
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer className="bg-blue-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* College Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.jpeg" alt="College Logo" className="h-16 w-auto bg-white rounded-lg p-1" />
            </div>
            <p className="text-sm leading-relaxed mb-4">
              RDS SNATAKOTTAR MAHAVIDYALAY is committed to providing quality education and fostering academic excellence with holistic development of students.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social, idx) => (
                <a
                  key={idx}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${social.color} ${social.hover} w-8 h-8 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110`}
                  aria-label={social.Icon.name}
                >
                  <social.Icon className="text-sm" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <LinkColumn title="Quick Links" links={quickLinks} />

          {/* Important Links */}
          <LinkColumn title="Important Links" links={importantLinks} />

          {/* Contact Info & Newsletter */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4 relative">
              Contact Info
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-blue-600 mt-2"></span>
            </h3>
            <div className="space-y-3 mb-6">
              {contactDetails.map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <item.Icon className="text-blue-600 mt-1 flex-shrink-0" />
                  <p className="text-sm text-white">{item.text}</p>
                </div>
              ))}
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="text-white font-semibold mb-2 text-sm">Subscribe to Newsletter</h4>
              <form onSubmit={handleSubscribe} className="flex">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="flex-1 px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-l-lg focus:outline-none focus:border-blue-600 text-white"
                />
                <button type="submit" className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-r-lg transition">
                  <MdSend className="text-white" />
                </button>
              </form>
              <p className="text-xs text-gray-500 mt-2">Get latest updates and news directly in your inbox.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="text-white text-center md:text-left">© {currentYear} RDS SNATAKOTTAR MAHAVIDYALAY. All rights reserved.</p>
          <div className="flex gap-4 mt-2 md:mt-0">
            {bottomLinks.map((link, idx) => (
              <Link key={idx} to={link.href} className="text-white hover:text-blue-600 transition">
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-lg transition hover:scale-110 z-50"
        aria-label="Scroll to top"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
    </footer>
  );
};

export default Footer;